import { DirectTask, TrueworkJsStrategy } from '@frame/lib/api/tasks/types'

export enum ClientSessionState {
  INITIALIZED = 'initialized',
  WAITING_FOR_INSTANT_DATA = 'waiting-for-instant-data',
  CONSENT = 'consent',
  EMPLOYMENTS = 'employments',
  TERMINAL_COMPLETE = 'terminal-complete',
  TERMINAL_COMPLETE_BY_OTHER_STRATEGY = 'terminal-complete-by-other-strategy',
  TERMINAL_EXPIRED = 'terminal-expired',
  TERMINAL_FALLBACK = 'terminal-fallback',
  TERMINAL_FAILED = 'terminal-failed',
}

export enum VerificationType {
  EMPLOYMENT = 'employment',
  EMPLOYMENT_INCOME = 'employment-income',
  INCOME_ONLY = 'income-only',
  TENANT_SCREENING = 'tenant-screening',
}

export enum VerifierRequirements {
  EMPLOYMENT_2_YEARS = 'employment_2_years',

  EMPLOYMENT_3_YEARS = 'employment_3_years',
  INCOME_CURRENT = 'income_current',
}

type CobrandingTenantProperty = {
  property_name: string
}

type DirectSettings = {
  disable_other_income_flow?: boolean | null
  verifier_requirements?: VerifierRequirements | null
  docs_upload_screen_copy?: string | null
}

type Configuration = {
  tasks?: {
    screen_text: string | null
    can_add: boolean
  }
  credentials: {
    enabled: boolean
  }
  cobranding: {
    logo_url: string | null
    button_color: string | null
    tenant_property: CobrandingTenantProperty | null
  }
  enabled_strategies: TrueworkJsStrategy[]
  skip_applicant_stated_info: boolean
  docs_for_mortgage_enabled: boolean
  settings?: DirectSettings | null
}

export type ClientSessionResponse = {
  id: string
  state: ClientSessionState
  originating_party_display_name: string
  consumer_initiated: boolean
  tasks: DirectTask[]
  configuration: Configuration
  verification_type: VerificationType
  max_employments: number
  verifier?: string // TODO: Make this required
  verifier_type?: string
  target_first_name: string | null
  enabled_features?: string[]
  blend_id?: string
  target_phone_number?: string | null
}
